import { all, fork, takeEvery } from 'redux-saga/effects';
import { types } from './reducer';
import pagination from '@iso/lib/helpers/pagination';
import AlertService from '@iso/services/SettingsService/AlertService';

function* watchFetchAlerts() {
    yield takeEvery(
        types.REQUEST_FETCH_ALERTS,
        pagination('alerts').saga(AlertService),
    );
}

function* paginationSaga() {
    yield all([
        fork(watchFetchAlerts),
    ]);
}

export default paginationSaga;